<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.question }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-button [mat-dialog-close]="false">{{ buttonLabel.no }}</button>
  <button type="button" mat-button [mat-dialog-close]="true" [ngClass]="{ critical: !data.disableCritical }">
    {{ buttonLabel.yes }}
  </button>
</mat-dialog-actions>
